import { FieldValues, Path } from "react-hook-form";

export function safeZodPath<T extends FieldValues>(
    path: Path<T>
): Array<string | number> {
    return path.split(".");
}
